import { ArrowRight } from 'lucide-react';

interface ManualCorrectionDiffProps {
  /** Value that the AI originally extracted. */
  originalValue: unknown;
  /** Value the user typed after their edit. */
  correctedValue: unknown;
}

function format(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '(vacío)';
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

/**
 * Shows the original AI value next to the corrected one when a field has been edited.
 * Hidden when the values match — the parent only renders this when an edit landed.
 */
export function ManualCorrectionDiff({
  originalValue,
  correctedValue,
}: ManualCorrectionDiffProps): JSX.Element | null {
  const original = format(originalValue);
  const corrected = format(correctedValue);
  if (original === corrected) {
    return null;
  }
  return (
    <p
      className="animate-fade-in mt-1 flex flex-wrap items-center gap-1 text-[11px] text-slate-500"
      data-testid="manual-correction-diff"
    >
      <span className="font-medium uppercase tracking-wider text-indigo-600">Antes</span>
      <span className="rounded border border-slate-200 bg-slate-50 px-1.5 py-0.5 font-mono text-slate-500 line-through">
        {original}
      </span>
      <ArrowRight className="h-3 w-3 text-slate-400" aria-hidden strokeWidth={2.25} />
      <span className="rounded border border-indigo-200 bg-indigo-50 px-1.5 py-0.5 font-mono text-indigo-700">
        {corrected}
      </span>
    </p>
  );
}
